import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b0cdbdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = { class: "map-content-area" }
const _hoisted_3 = {
  ref: "mapContainer",
  id: "map"
}
const _hoisted_4 = { class: "upper-btns" }
const _hoisted_5 = {
  key: 0,
  class: "middle-btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: $setup.title }, null, 8 /* PROPS */, ["title"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */),
          _createElementVNode("section", _hoisted_4, [
            _createVNode($setup["MapZoomLevelSetter"], {
              class: "zoom-level",
              zoomLevel: $setup.zoomLevel,
              maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
              minZoomLevel: $setup.MIN_ZOOM_LEVEL,
              onZoomIn: _cache[0] || (_cache[0] = ($event: any) => ($setup.increaseZoomLevel($setup.map))),
              onZoomOut: _cache[1] || (_cache[1] = ($event: any) => ($setup.decreaseZoomLevel($setup.map)))
            }, null, 8 /* PROPS */, ["zoomLevel"]),
            _createElementVNode("button", {
              class: "img-btn-wrapper",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowRoadEventListModal(true))),
              "aria-label": "교통정보 보기"
            }, [
              _createVNode($setup["InlineSvg"], {
                class: "img-btn",
                src: require('@/assets/icons/road-event.svg'),
                alt: "교통정보 보기",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["img-btn-wrapper", { disabled: !$setup.selectedBusStop }]),
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowStreetView(true))),
              "aria-label": "거리뷰 보기"
            }, [
              _createVNode($setup["InlineSvg"], {
                class: "img-btn",
                src: require('@/assets/icons/street-view.svg'),
                alt: "거리뷰 보기",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ], 2 /* CLASS */),
            ($setup.shouldShowLocationRefreshButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  ref: "refreshButton",
                  class: _normalizeClass(["img-btn-wrapper", { rotate: $setup.isRotating }]),
                  type: "button",
                  onClick: $setup.onClickRefreshBtn,
                  "aria-label": "새로 고침"
                }, [
                  _createVNode($setup["InlineSvg"], {
                    class: "img-btn",
                    src: require('@/assets/icons/rotate.svg'),
                    alt: "새로 고침",
                    "aria-hidden": "true"
                  }, null, 8 /* PROPS */, ["src"])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.windowHeight > 667 && $setup.busStops.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _createElementVNode("button", {
                  class: "left-stop-btn-wrapper",
                  type: "button",
                  onClick: $setup.movePreviousBusStop,
                  "aria-label": "이전 정류장 보기"
                }, [
                  _createVNode($setup["InlineSvg"], {
                    class: "img-left-btn",
                    src: require('@/assets/icons/chevron-left-medium.svg'),
                    alt: "이전 정류장 보기",
                    "aria-hidden": "true"
                  }, null, 8 /* PROPS */, ["src"])
                ]),
                _createElementVNode("button", {
                  class: "right-stop-btn-wrapper",
                  type: "button",
                  onClick: $setup.moveNextBusStop,
                  "aria-label": "다음 정류장 보기"
                }, [
                  _createVNode($setup["InlineSvg"], {
                    class: "img-right-btn",
                    src: require('@/assets/icons/chevron-right-medium.svg'),
                    alt: "다음 정류장 보기",
                    "aria-hidden": "true"
                  }, null, 8 /* PROPS */, ["src"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.busStops.length)
            ? (_openBlock(), _createBlock($setup["MapOfNearbyBusStopsBottomSheet"], {
                key: 1,
                ref: "bottomSheetModal",
                busStops: $setup.busStops,
                selectedBusStop: $setup.selectedBusStop!,
                lineInfos: $setup.lineInfos,
                maxHeightPx: $setup.maxHeightPx,
                initalIndex: $setup.initalIndex,
                onOnSlideChange: $setup.updateSelectedBusStop
              }, null, 8 /* PROPS */, ["busStops", "selectedBusStop", "lineInfos", "maxHeightPx", "initalIndex"]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowStreetView,
        onBackHandler: () => $setup.toggleShowStreetView(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["BusStopStreetView"], {
            title: $setup.selectedBusStop?.name,
            latitude: $setup.selectedBusStop?.latitude,
            longitude: $setup.selectedBusStop?.longitude,
            onOnClickClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowStreetView(false)))
          }, null, 8 /* PROPS */, ["title", "latitude", "longitude"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowRoadEventListModal,
        onBackHandler: () => $setup.toggleShowRoadEventListModal(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["RoadEventListModal"], {
            class: "road-event-list-container",
            routeUid: $setup.lineInfo?.id ?? '',
            onOnClickClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleShowRoadEventListModal(false)))
          }, null, 8 /* PROPS */, ["routeUid"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}